const user = "admin";
const pw = "passord";
const prisGjest = 83;
const prisMedlem = 64;
const prisJuniorGjest = 42;
const prisJuniorMedlem = 32;
const maxPrisKlubbkveld = 512;

export default {
    user,
    pw,
    prisGjest,
    prisMedlem,
    prisJuniorGjest,
    prisJuniorMedlem,
    maxPrisKlubbkveld
}